module.exports = require("./uz-Cyrl.d.ts");